import { DBProduct } from "../types/product";
import { RestProductOverlayChainValues } from "../types/productOverlay";

export const applyChainValues = (
  product: DBProduct,
  { variants: chainVariants, ...chainValues }: RestProductOverlayChainValues,
): DBProduct => ({
  ...product,
  ...chainValues,
  variants: product.variants?.map((variant) => ({
    ...variant,
    ...chainVariants?.find((item) => item.id === variant.id),
  })),
});
